import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class UserTopicService extends ServiceBase {
    /**
     * Gets all topic groups for user.
     * @returns {Promise}
     */
    getGroups = () => {
        const url = `${baseUrl}/${service}/user/topics/groups`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Gets entries for a topic group node.
     * @param {string} gid - TopicGroup RK
     * @param {string} node - g1 | g2 | g3 | g4
     * @param {number} page
     * @param {number} size
     * @returns {Promise}
     */
    getGroupEntries = (gid, node, page = 1, size = 25) => {
        const url = `${baseUrl}/${service}/user/topics/groups/entries?page=${page}&size=${size}&node=${node}&gid=${gid}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Gets all nodes for a topic group — used on manual group switch.
     * Returns same shape as OnGroupNodesLoaded SignalR event.
     * @param {string} gid - TopicGroup RK
     * @returns {Promise}
     */
    getGroupNodes = (gid) => {
        const url = `${baseUrl}/${service}/user/group/nodes?gid=${gid}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Searches entries by query string.
     * @param {{ q: string, page?: number, size?: number }} dto
     * @returns {Promise}
     */
    search = (dto) => {
        const { rk, q, topic, page = 1, size = 25 } = dto;
        if (!q || q.trim().length < 3) return -1;

        const url = `${baseUrl}/${service}/user/topics/search?q=${encodeURIComponent(q)}&group=${encodeURIComponent(topic)}&page=${page}&size=${size}&rk=${rk}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    searchCleanup = (dto) => {
        const url = `${baseUrl}/${service}/user/topics/search/action`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.post(url, dto, config);
    };

    /**
     * Saves a topic group.
     * @param {object} dto
     * @returns {Promise}
     */
    saveGroup = (dto) => {
        const url = `${baseUrl}/${service}/user/topics/group`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.post(url, dto, config);
    };

    /**
     * Persists active node and entry selection for a group.
     * @param {{ gid, nid, eid }} dto
     * @returns {Promise}
     */
    saveGroupActivity = (dto) => {
        const url = `${baseUrl}/${service}/user/group/activity`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.post(url, dto, config);
    };

    /**
     * Updates the body of an existing journal entry.
     * @param {string} rk
     * @param {string} body
     * @returns {Promise}
     */
    updateJournalBody = (rk, body) => {
        const url = `${baseUrl}/${service}/journal/body`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: { rk, body } }, config);
    };
}

const userTopicService = new UserTopicService();
export default userTopicService;
